module.exports = __webpack_public_path__ + "img/about_us.93555b46.png";